// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__6c-1c","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3Zd-o"};